import { Button, Card, Dialog, Radio, RadioGroup } from '@mui/material';
import * as React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AppSelector } from '@data/app/app.selector';
import useAppDispatch from '@data/useAppDispatch';
import { copyContents } from '@data/contents/Contents.thunk';
import { LoadingButton } from '@mui/lab';

export interface ContentCopyModalProps {
  selectedContentIds: string[];
  onClose: () => void;
  resetSelectedContents: () => void;
}

export const ContentCopyModal = (props: ContentCopyModalProps) => {
  const { onClose, selectedContentIds, resetSelectedContents } = props;

  const communities = useSelector(AppSelector.selectAvailableCommunities);

  const parsedCommunities = useMemo(() => {
    return Object.values(communities);
  }, [communities]);

  const [selectedCommunity, setSelectedCommunity] = React.useState<
    string | null
  >(null);

  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleCopy = () => {
    if (!selectedCommunity) return;
    setIsLoading(true);
    dispatch(
      copyContents({
        contentIds: selectedContentIds,
        targetCommunity: selectedCommunity,
      }),
    ).then(() => {
      resetSelectedContents();
      setIsLoading(false);
      onClose();
    });
  };

  return (
    <Dialog open>
      <Card className="pt-10 w-[371px] flex-col-center p-[20px]">
        <div className="w-full text-left h4 text-brand-primary">
          Copy Content
        </div>
        <div className="w-full max-h-full mt-2 h4 text-brand-secondary">
          Are you sure you want revert these contents to a draft?
          <ul className="mb-8" style={{ maxHeight: '10rem', overflow: 'auto' }}>
            <RadioGroup>
              {parsedCommunities.map((community) => (
                <li
                  key={community.displayName}
                  className="flex items-center justify-between mt-2"
                >
                  <span>{community.displayName}</span>
                  <Radio
                    checked={selectedCommunity === community.key}
                    onChange={() => setSelectedCommunity(community.key)}
                  />
                </li>
              ))}
            </RadioGroup>
          </ul>
          <span className="font-bold subtitle1">
            Any Series will be removed from all interactions and no longer
            visible in the Discover section.{' '}
            <span className="text-error">All progress will be reset.</span>
          </span>
        </div>
        <div className="flex justify-center mt-[30px]">
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            className="w-[130px] h-[40px] !mr-[10px] !ml-[10px]"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <LoadingButton
            onClick={handleCopy}
            className="w-[130px] h-[40px] !mr-[10px] !ml-[10px]"
            variant="contained"
            color="primary"
            disabled={selectedCommunity === null || isLoading}
            loading={isLoading}
          >
            Confirm
          </LoadingButton>
        </div>
      </Card>
    </Dialog>
  );
};
